module.exports = __webpack_public_path__ + "img/mobile-help-5.77ab383a.jpg";